import { QuestionTypes } from '@showbie-socrative/socrative-utils';
import { useMutation } from '@tanstack/react-query';

import { AoIQuestionsGeneratedEventAdapter } from '~analytics/adapters/AoIQuestionsGeneratedEventAdapter';

import { generateQuestionByAreasOfImprovement } from '../../../api/ai/generateQuestionByAreasOfImprovement';

export function useGenerateQuestionsByAreasOfImprovement() {
  return useMutation({
    mutationFn: generateQuestionByAreasOfImprovement,
    onSuccess: (
      {
        usage: { promptTokens, completionTokens },
        questions,
        elapsedTime,
        version,
      },
      { insightIndexes, questionCount, generateExplanations }
    ) => {
      const { numMc, numTf, numSa } = questions.reduce(
        (acc, question) => {
          switch (question.questionType) {
            case QuestionTypes.MultipleChoice:
              acc.numMc++;
              break;
            case QuestionTypes.TrueFalse:
              acc.numTf++;
              break;
            case QuestionTypes.FreeResponse:
              acc.numSa++;
              break;
          }
          return acc;
        },
        { numMc: 0, numTf: 0, numSa: 0 }
      );
      new AoIQuestionsGeneratedEventAdapter({
        num_aoi_selected: insightIndexes.length,
        input_token: promptTokens,
        output_token: completionTokens,
        elapsed_time: elapsedTime,
        generation_version: version,
        num_mc: numMc,
        num_tf: numTf,
        num_sa: numSa,
        total_questions: questionCount,
        generate_explanations: generateExplanations,
      }).sendAnalytics();
    },
  });
}
